import { TranslationCatalog } from './translations.types';

export const AUTH_OTP_TRANSLATIONS: TranslationCatalog = {
  es: {
    'otp.title': 'Autenticación requerida',
    'otp.body':
      'Te enviamos un código de verificación por mensaje de texto al número terminado en *****{last}. Ingresa el código para confirmar que eres tú.',
    'otp.valid': 'Código validado correctamente.',
    'otp.error.invalid': 'Parece que el código que ingresaste no es correcto. Vuelve a intentarlo con un código válido.',
    'otp.error.expired': 'El código expiró. Solicita uno nuevo para continuar.',
    'otp.error.incomplete': 'Completa los 6 dígitos del código.',
    'otp.error.alreadyValidated': 'Este código ya fue validado.',
    'otp.error.generic': 'No pudimos validar el código. Intenta nuevamente.',
    'otp.error.server': 'Ocurrió un error en el servidor. Intenta nuevamente.',
    'otp.error.sendFailed': 'No pudimos reenviar el código. Intenta nuevamente.',
    'otp.noCode': '¿No recibiste el código?',
    'otp.resend': 'Reenviar código en {time}',
    'otp.resendReady': 'Reenviar código',
    'otp.countdown': 'Expira en {time}',
    'otp.success.eyebrow': 'Cuenta verificada',
    'otp.success.title': 'Bienvenido(a) a WeMatch',
    'otp.success.titleNamed': 'Bienvenido(a), {name}',
    'otp.success.preparing': 'Estamos iniciando tu sesión y preparando tu espacio principal.',
    'otp.success.redirecting': 'Serás redirigido(a) a la página principal en unos segundos.',
    'otp.success.countdownLabel': 'segundos para entrar',
    'otp.success.loginFailed':
      'Tu cuenta ya quedó verificada, pero no pudimos iniciar sesión automáticamente. Continúa desde el acceso.',
    'otp.success.loginAction': 'Ir a iniciar sesión',
  },
  en: {
    'otp.title': 'Authentication required',
    'otp.body':
      'We sent a verification code by text message to the number ending in *****{last}. Enter the code to confirm it is you.',
    'otp.valid': 'Code validated successfully.',
    'otp.error.invalid': 'The code you entered does not look correct. Try again with a valid code.',
    'otp.error.expired': 'The code expired. Request a new one to continue.',
    'otp.error.incomplete': 'Complete the 6 code digits.',
    'otp.error.alreadyValidated': 'This code has already been validated.',
    'otp.error.generic': 'We could not validate the code. Please try again.',
    'otp.error.server': 'A server error occurred. Please try again.',
    'otp.error.sendFailed': 'We could not resend the code. Please try again.',
    'otp.noCode': 'Did not receive the code?',
    'otp.resend': 'Resend code in {time}',
    'otp.resendReady': 'Resend code',
    'otp.countdown': 'Expires in {time}',
    'otp.success.eyebrow': 'Account verified',
    'otp.success.title': 'Welcome to WeMatch',
    'otp.success.titleNamed': 'Welcome, {name}',
    'otp.success.preparing': 'We are signing you in and preparing your main space.',
    'otp.success.redirecting': 'You will be redirected to the main page in a few seconds.',
    'otp.success.countdownLabel': 'seconds to enter',
    'otp.success.loginFailed':
      'Your account is already verified, but we could not sign you in automatically. Continue from login.',
    'otp.success.loginAction': 'Go to login',
  },
};
